import axios from "axios";

interface IUploadJimpiFileParams {
    file: File
}

export const uploadJimpiFile = async (params: IUploadJimpiFileParams): Promise<void> => {
    const response = await axios.post(
        '/booking/import/uploadjimpi',
        params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
    return response.data;
};

export default uploadJimpiFile;